import request from '@core/services/request';

export const usersAPI = {
	//gets
	getByCode: (userCode: any) => request.get(`/GetUserInfo/` + userCode),
	//sets
	setUser: (user: any) => request.post(`/SetEmployee`, user),
	resendPasswordEmail: (user: any) => request.post(`/ResendPasswordEmail`, user),
	removeUser: (id: any) => request.post(`/DeleteEmployee?id=${id}`),
	updateUserPassword: (userLogin: any, userPassword: any, userNewPassword: any) =>
		request.post(`/UpdateUserPassword`, {
			userLogin,
			userPassword,
			userNewPassword,
		}),
	cashBash: {
		getCards: (cashbashid: any) => request.get(`/CashBash/GetCards/`, cashbashid),
		closeNoLive: (cashbashid: any) => request.post(`/CashBash/CloseNoLive`, cashbashid),
		setCard: (cardSetup: any) => request.post(`/CashBash/SetCard/`, cardSetup),
		create: (cashBashSetup: any) => request.post(`/CashBash/Create/`, cashBashSetup),
		updateCashBashWithFlattenedEmployees: (cashBashSetup: any) => request.post(`/CashBash/UpdateCashBashWithFlattenedEmployees/`, cashBashSetup),
		getAll: () => request.get('/CashBash/GetAll'),
		getById: (cashbashid: any) => request.get('/CashBash/GetById', cashbashid),
		setClosed: (cashbashId: any) => request.post('/CashBash/SetClosed', cashbashId),
		setFinished: (cashbashId: any) => request.post('/CashBash/SetFinished', cashbashId),
		resetCardSelection: (cashbashId: any) => request.post('/CashBash/ResetCardSelection', cashbashId),
		setActive: (cashbashId: any) => request.post('/CashBash/SetActive', cashbashId),
		getActual: () => request.get('/CashBash/GetActual'),
		getActualToPlay: () => request.get('/CashBash/GetActualToPlay'),
		deleteById: (cashbashId: any) => request.post(`/CashBash/DeleteCashBashById/${cashbashId}`),
		getCBFromProd: () => request.get(`/CashBash/GetCBFromProd`),
		copyCBFromProd: (cashbashId: any) => request.post(`/CashBash/CopyCBFromProd`, { cashbashId }),
		getAllEmployees: () => request.get(`/CashBash/GetAllEmployees`),
	},
	eSignMobile: {
		getESignUrl: (data: any) => request.post(`/ESign/GetESignUrl`, data),
		startSigning: (eSignId: any) => request.post(`/ESign/StartSigning/${eSignId}`),
		uploadSignatureAndInitials: (eSignId: any, employeeSignature: any, employeeInitials: any) =>
			request.post(`/ESign/UploadSignatureAndInitials`, {
				eSignId,
				employeeSignature,
				employeeInitials,
			}),
	},
};
